import useWindowSize from './use-window-size';

export const useIsMobile = () => {
  const { width } = useWindowSize();
  const isMobile = width <= 900;
  return isMobile;
};
